import React, { useMemo } from 'react'
import CodeMirrorBase from '@uiw/react-codemirror'
import { css } from '@codemirror/lang-css'
import { javascript } from '@codemirror/lang-javascript'
import { useTheme } from '@mui/material/styles'

const langExtensions = {
  css,
  javascript,
}

export const CodeMirror = ({
  value,
  options = {},
  onBeforeChange,
  onChange,
  className,
  height,
}) => {
  const { mode, lineNumbers = true, tabSize = 2, readOnly = false } = options

  /**
   * Anders als im Plan beschrieben läuft hier CodeMirror 6 über
   * @uiw/react-codemirror, nicht CodeMirror 5. Das Theme kommt deshalb über
   * dieses Prop und nicht über eine der CSS-Dateien unter
   * /public/plugins/codemirror/theme/ — die stammen aus der CM5-Zeit und
   * greifen auf `.CodeMirror`, eine Klasse, die CM6 gar nicht mehr erzeugt.
   *
   * Der Code-Editor ist Editor-Chrome, keine WYSIWYG-Schreibfläche: hier wird
   * Theme-Code bearbeitet, kein Shop-Text. Er folgt dem Modus.
   */
  const isDark = useTheme().palette.mode === 'dark'

  const extensions = useMemo(() => {
    const langFactory = langExtensions[mode]
    return langFactory ? [langFactory()] : []
  }, [mode])

  const basicSetup = useMemo(
    () => ({ lineNumbers, tabSize }),
    [lineNumbers, tabSize]
  )

  const handleChange = (val) => {
    if (onBeforeChange) onBeforeChange(null, null, val)
    if (onChange) onChange(null, null, val)
  }

  return (
    <CodeMirrorBase
      className={className}
      value={value || ''}
      height={height}
      theme={isDark ? 'dark' : 'light'}
      readOnly={readOnly}
      extensions={extensions}
      basicSetup={basicSetup}
      onChange={handleChange}
    />
  )
}
